import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  Fade,
  CircularProgress,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";

// styles
import useStyles from "../styles";
import TimerOffIcon from "@material-ui/icons/TimerOff";

// logo
import logo from "images/logoLoginRS.png";

// context
import { dbPut, dbGet } from "utils/DBFetchers.js";
import routes from "routes";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import PasswordCreationFields, {
  isPasswordStrongEnough,
  passwordsMatch,
} from "components/CustomFields/PasswordCreationFields";

function PasswordResetForm(props) {
  let classes = useStyles();

  // local
  let [isTokenValid, setIsTokenValid] = useState(null);
  let [isLoading, setIsLoading] = useState(false);
  let [passwordValue1, setPasswordValue1] = useState("");
  let [passwordValue2, setPasswordValue2] = useState("");
  const [isFormValid, setIsFormValid] = useState({ valid: false, message: "" });
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const passwordMeetsCriteria = isPasswordStrongEnough(passwordValue1);
  const passwordsMatchConfirmation = passwordsMatch(
    passwordValue1,
    passwordValue2,
  );
  const checkFormValid = () => {
    if (!passwordMeetsCriteria) {
      setIsFormValid({
        valid: false,
        message: "La contraseña debe cumplir todos los criterios de seguridad",
      });
      return false;
    } else if (!passwordsMatchConfirmation) {
      setIsFormValid({
        valid: false,
        message: "Las contraseñas deben coincidir",
      });
      return false;
    }
    setIsFormValid({
      valid: true,
      message: "",
    });
    return true;
  };

  const handlePageToken = () => {
    let token = props.location.pathname.split("cambiar-clave/")[1];
    dbGet(`/update-token-check?token=${token}`)
      .then((data) => {
        setIsTokenValid(true);
      })
      .catch((error) => {
        setIsTokenValid(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!checkFormValid()) {
      return;
    }
    let token = props.location.pathname.split("cambiar-clave/")[1];
    setIsLoading(true);
    let passwordData = {
      password: passwordValue1,
    };
    dbPut(`users/reset-password?token=${token}`, passwordData)
      .then((data) => {
        snackbarOpen("success", "Contraseña editada exitosamente");
        setTimeout(() => {
          props.history.push(routes.login);
        }, 3000);
      })
      .catch((error) => {
        setIsLoading(false);
        snackbarOpen(
          "error",
          error[0] ? error[0].description_es : "Error al editar contraseña",
        );
        return;
      });
  };

  const handleGoLogin = (e) => {
    e.preventDefault();
    props.history.push(routes.login);
  };

  /* On page load, get all data */
  React.useEffect(() => {
    handlePageToken();
  }, []);

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logo} alt="logo" className={classes.logotypeImage} />
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <CustomizedSnackbars
            severity={snackbarStatus.severity}
            mssg={snackbarStatus.message}
            open={snackbarStatus.open}
            onClose={onCloseSnackbar}
          />
          {isTokenValid ? (
            <>
              <form onSubmit={handleSubmit}>
                <div>
                  <Typography
                    variant="h3"
                    align="center"
                    style={{ fontWeight: "bold" }}
                  >
                    Nueva contraseña
                  </Typography>{" "}
                </div>
                <div className={classes.formDividerContainer}>
                  <div className={classes.formDivider} />
                </div>
                <Typography variant="h6" align="center">
                  Ingresa una nueva contraseña
                </Typography>
                <Fade in={!isFormValid.valid}>
                  <Typography
                    color="secondary"
                    className={classes.errorMessage}
                  >
                    {isFormValid.message}
                  </Typography>
                </Fade>
                <PasswordCreationFields
                  password={passwordValue1}
                  confirmation={passwordValue2}
                  onPasswordChange={(event) =>
                    setPasswordValue1(event.target.value)
                  }
                  onConfirmationChange={(event) =>
                    setPasswordValue2(event.target.value)
                  }
                />
                <div className={classes.formButtonsPassReset}>
                  {isLoading ? (
                    <CircularProgress
                      size={26}
                      className={classes.loginLoader}
                      style={{ marginLeft: "0%" }}
                    />
                  ) : (
                    <Button
                      disabled={
                        !passwordMeetsCriteria || !passwordsMatchConfirmation
                      }
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Cambiar contraseña
                    </Button>
                  )}
                </div>
              </form>
            </>
          ) : isTokenValid === false ? (
            <div align="center">
              <TimerOffIcon
                fontSize="large"
                style={{ marginBottom: 20 }}
              ></TimerOffIcon>
              <Typography
                variant="h4"
                align="center"
                style={{ marginBottom: 100 }}
              >
                El link de recuperación ha expirado
              </Typography>
              <Button
                onClick={handleGoLogin}
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className={classes.backButtonsPassReset}
              >
                Volver
              </Button>
            </div>
          ) : (
            <CircularProgress
              size={26}
              className={classes.loginLoader}
              style={{ marginLeft: "45%" }}
            />
          )}
        </div>
        <Typography color="primary" className={classes.copyright}>
          By Dynaxo Corp.
        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(PasswordResetForm);
